import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useShowInternalTools = () => {
  const router = useRouter();
  const [showInternalTools, setShowInternalTools] = useState(false);

  useEffect(() => {
    if (router.isReady) {
      setShowInternalTools(router.query.showInternalTools === 'true');
    }
  }, [router.isReady, router.query.showInternalTools]);

  return showInternalTools;
};
